import { render, staticRenderFns } from "./Tarot.vue?vue&type=template&id=46ed5b16&"
import script from "./Tarot.vue?vue&type=script&lang=js&"
export * from "./Tarot.vue?vue&type=script&lang=js&"
import style0 from "./Tarot.vue?vue&type=style&index=0&id=46ed5b16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports